import React from "react";
import {Helmet} from "react-helmet";

const Admin = () => {
    return (
        <>
            <Helmet>
                <title>Admin | Rafael Acosta Martinez</title>
            </Helmet>
            <div>
                AdminHome
            </div>
        </>
    )
}

export default Admin